// extracted by mini-css-extract-plugin
export default {"role":"ECf2j","roleFieldWrapper":"cvhmo","deleteMemberButtonWrapper":"aeJmV"};